import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { FilesState } from "./types";
import { getFileContentAction, uploadFileAction } from "./actions";

export function uploadFileReducerBuilder(
  builder: ActionReducerMapBuilder<FilesState>,
) {
  builder.addCase(uploadFileAction.pending, (state, action) => {
    state.isFileLoading = true;
  });
  builder.addCase(uploadFileAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    const { value } = action.payload;
    state.filesValue = value ?? null;
    state.isFileLoading = false;
  });
  builder.addCase(uploadFileAction.rejected, (state, action) => {
    state.isFileLoading = false;
  });
}

export function getFileContentReducerBuilder(
  builder: ActionReducerMapBuilder<FilesState>,
) {
  builder.addCase(getFileContentAction.pending, (state) => {
    state.isFileLoading = true;
  });
  builder.addCase(getFileContentAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.fileConfig = action.payload;
    state.isFileLoading = false;
  });
  builder.addCase(getFileContentAction.rejected, (state) => {
    state.isFileLoading = false;
  });
}
